import React from 'react';
import { Pressable as RNPressable, PressableProps as RNPressableProps, StyleSheet, ViewStyle, StyleProp } from 'react-native';

export interface PressableProps extends RNPressableProps {
    variant?: 'primary' | 'secondary' | 'danger' | 'ghost' | 'none';
    size?: 'sm' | 'md' | 'lg';
    isLoading?: boolean;
    children?: React.ReactNode;
    style?: StyleProp<ViewStyle>;
    className?: string; // Web escape hatch
}

/**
 * Pressable Component - Universal Touchable Wrapper
 * Handles touch interactions consistently across Mobile and Web.
 * Renders as a <button> on web and as a native touchable on Mobile.
 */
export const Pressable: React.FC<PressableProps> = ({
    variant = 'none',
    size = 'md',
    isLoading = false,
    disabled,
    style,
    children,
    ...props
}) => {
    return (
        <RNPressable
            disabled={disabled || isLoading}
            style={({ pressed }) => [
                {
                    opacity: disabled || isLoading ? 0.5 : pressed ? 0.8 : 1,
                },
                // Ensure style is correctly passed down
                StyleSheet.flatten(style as StyleProp<ViewStyle>),
            ]}
            accessibilityRole="button"
            accessibilityState={{ disabled: !!(disabled || isLoading) }}
            {...props}
        >
            {children}
        </RNPressable>
    );
};
